import { render } from "./now.vue?vue&type=template&id=117da8df&scoped=true"
import script from "./now.vue?vue&type=script&lang=js"
export * from "./now.vue?vue&type=script&lang=js"

import "./now.vue?vue&type=style&index=0&id=117da8df&scoped=scoped&lang=css"

import exportComponent from "D:\\CODE\\clpgaAppDevnew\\clpga_html\\f_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-117da8df"]])

export default __exports__